import { useState, useEffect, useRef } from 'react';


export default function ResizeBar({onColumnSizeChange, width, minWidth, columnIndex, renderedWidthRef,col}){

  const [ originalWidth, setOriginalWidth ] = useState(width);
  const [ mouseDownStart, setMouseDownStart ] = useState(null);


  const mouseUp = () => {
    setMouseDownStart(null);

  }
  const mouseMove = e => {

    if( mouseDownStart !== null ){

      let deltaWidth = -(mouseDownStart - e.clientX)
      let newWidth = originalWidth + deltaWidth; 

      if( minWidth && !isNaN(minWidth) ){
        if( newWidth >= minWidth ){
          onColumnSizeChange(col.property, newWidth);
        }
      }else{
        onColumnSizeChange(col.property, newWidth);
      }
    }
  }


  useEffect(() => {
    window.addEventListener('mouseup',mouseUp);
    window.addEventListener('mousemove',mouseMove);
    return () => {
      window.removeEventListener('mouseup',mouseUp);
      window.removeEventListener('mousemove',mouseMove);
    }
  })



  
  return (



    <div onMouseDown={e => {
      e.stopPropagation();
      e.preventDefault();
      setMouseDownStart(e.clientX);
      //let originalWidth = e.target.getBoundingClientRect().width;
      console.log("renderedWidthRefCurrent = " + renderedWidthRef.current);
      setOriginalWidth(renderedWidthRef.current);

    }}
      onClick={e => {
        //this makes sure that when you resize this column
        //it doesn't resort them on the column you click
        e.stopPropagation();
      }}
      style={{
      cursor:'ew-resize',
      position:'absolute',
      right:0,
      top:0,
      height:'100%',
      background:'#ccc',
      width:4
    }}/>

  )






}
